import { render, staticRenderFns } from "./BlueShadow.vue?vue&type=template&id=dec39a52&scoped=true&lang=pug"
import script from "./BlueShadow.vue?vue&type=script&lang=js"
export * from "./BlueShadow.vue?vue&type=script&lang=js"
import style0 from "./BlueShadow.vue?vue&type=style&index=0&id=dec39a52&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec39a52",
  null
  
)

export default component.exports